module.exports = __webpack_public_path__ + "static/GTAmerica-BoldItalic-5f05f19b667feeab33a7938e44cae7f8.woff2";